import { put, call, take, fork } from 'redux-saga/effects'
import { cardAddInsideCourseService } from '../../api/card'
import { cardAddSuccess } from '../../reducers/card/action'
import { CARD_ADD } from '../../reducers/card/type'
import generalSaga from '../general'
import {
  operationSuccess,
  operationFail,
} from '../../reducers/operation/action'

/**
 *
 * @param {*} payload
 */
function* cardAddFlow(payload) {
  try {
    const { entity, courseId, callback } = payload
    const response = yield call(cardAddInsideCourseService, entity, courseId)

    yield put(cardAddSuccess(response.data))
    yield put(operationSuccess())

    callback(response.data)
  } catch (error) {
    yield put(operationFail(error))
  }
}

/**
 *
 */
export default function* cardAddWatcher() {
  while (true) {
    const action = yield take(CARD_ADD)
    const { payload } = action

    yield fork(generalSaga, cardAddFlow, payload)
  }
}
